import { ref } from 'vue'
import { backButtonCallback } from '@/router'

const showMinesweeperChallengeModal = ref(false)
const isReturningFromGame = ref(false)

export const useMinesweeperChallengeModal = () => {
  function openMinesweeperChallengeModal (fromGameReturn: boolean = false) {
    backButtonCallback.value = closeMinesweeperChallengeModal
    isReturningFromGame.value = fromGameReturn
    showMinesweeperChallengeModal.value = true
  }

  const closeMinesweeperChallengeModal = () => {
    backButtonCallback.value = null
    showMinesweeperChallengeModal.value = false
    setTimeout(() => {
      isReturningFromGame.value = false
    }, 300)
  }

  return {
    showMinesweeperChallengeModal,
    isReturningFromGame,
    openMinesweeperChallengeModal,
    closeMinesweeperChallengeModal,
  }
}